{
  "name": "trialbee-self-assessment",
  "version": "1.30.2",
  "private": true,
  "api": "dist/prescreener.js",
  "targets": {
    "api": {
      "source": "src/prescreener/prescreener.js",
      "distDir": "./dist",
      "engines": {
        "browsers": "> 0.25%, not dead"
      }
    },
    "app": {
      "source": "src/prescreener/selfAssessment.html",
      "distDir": "./dist",
      "engines": {
        "browsers": "> 0.25%, not dead"
      }
    }
  },
  "engines": {
    "node": ">=18.17.1"
  },
  "scripts": {
    "dev": "echo '🚨 Please use super-honey instead - `dev-frontend up widget`'",
    "dev:docker": "npm-run-all -p dev:docker:*",
    "dev:docker:parcel": "parcel --host 0.0.0.0 --no-cache --hmr-port 1236 --hmr-host 127.0.0.1  --no-hmr",
    "dev:docker:caddy": "caddy run --watch --config /code/Caddyfile",
    "build": "parcel build --no-cache",
    "clean": "rm -rf dist/ .parcel-cache",
    "start": "node dist/server.js",
    "build_local": "npm-run-all -p build_local:replace:*",
    "lint": "eslint src",
    "test": "echo Disabled jest",
    "test:size": "SIZE_LIMIT_CONFIG=\"prescreener\" size-limit --no-running-time",
    "test:watch": "jest --watch",
    "translations:pull": "mkdir -p ./dist/locale; npx poeditor-ci pull",
    "translations:expand": "babel-node --experimental-modules ./common/scripts/expandLanguages.mjs",
    "translations:clean": "babel-node ./common/scripts/cleanLanguages.js"
  },
  "dependencies": {
    "@babel/polyfill": "^7.12.1",
    "@babel/runtime": "^7.22.3",
    "@bugsnag/browser": "^7.20.0",
    "@bugsnag/js": "^7.20.0",
    "@bugsnag/plugin-react": "^7.19.0",
    "@formatjs/intl-pluralrules": "^1.5.2",
    "@formatjs/intl-relativetimeformat": "^4.5.9",
    "@material-ui/core": "^4.12.3",
    "@material-ui/icons": "^4.11.2",
    "@material-ui/styles": "^4.11.4",
    "@trialbee/eligibility-validator": "0.1.6",
    "body-scroll-lock": "^2.6.4",
    "classnames": "^2.2.6",
    "color": "^3.1.2",
    "core-js": "^3.6.4",
    "cors": "^2.8.5",
    "debounce": "^1.2.0",
    "express": "^4.17.1",
    "gherkin-lint": "^4.2.4",
    "google-map-react": "^1.1.6",
    "jexl": "^2.2.2",
    "jss": "^10.8.2",
    "jss-rtl": "^0.3.0",
    "libphonenumber-js": "^1.7.40",
    "lodash.get": "^4.4.2",
    "lodash.merge": "^4.6.2",
    "lodash.mergewith": "^4.6.2",
    "mixpanel-browser": "^2.45.0",
    "path": "^0.12.7",
    "prop-types": "^15.7.2",
    "react": "^16.12.0",
    "react-dom": "^16.12.0",
    "react-intl": "^6.5.5",
    "react-phone-input-2": "^2.11.0",
    "remark": "^11.0.2",
    "remark-react": "^6.0.0",
    "smoothscroll-polyfill": "^0.4.4",
    "string-placeholder": "^1.0.2",
    "validate.js": "^0.13.1"
  },
  "devDependencies": {
    "@babel/cli": "^7.23.4",
    "@babel/core": "^7.23.7",
    "@babel/eslint-parser": "^7.23.3",
    "@babel/node": "^7.22.19",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-syntax-dynamic-import": "^7.8.3",
    "@babel/plugin-syntax-jsx": "^7.23.3",
    "@babel/plugin-transform-runtime": "^7.23.7",
    "@babel/preset-env": "^7.23.8",
    "@babel/preset-react": "^7.23.3",
    "babel-eslint": "^10.1.0",
    "babel-plugin-add-module-exports": "^1.0.2",
    "babel-plugin-react-intl": "^7.5.18",
    "babel-plugin-transform-react-remove-prop-types": "^0.4.24",
    "bugsnag-sourcemaps": "^1.3.0",
    "eslint": "^8.56.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jest": "^27.6.3",
    "eslint-plugin-json": "^3.1.0",
    "eslint-plugin-jsx-a11y": "^6.8.0",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-react": "^7.33.2",
    "eslint-plugin-react-hooks": "^4.6.0",
    "events": "^3.1.0",
    "get-port": "^5.1.1",
    "jest": "^24",
    "nodemon": "^3.0.3",
    "npm-run-all": "^4.1.5",
    "parcel": "^2.11.0",
    "path-browserify": "^1.0.1",
    "prettier": "3.1.1",
    "size-limit": "^11.0.2"
  },
  "eslintConfig": {
    "extends": "react-app"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
